import LogoProsoft from "assets/logo.svg";

function Home() {
  return (
    <>
      {/* <h1 className="text-primary">Content</h1> */}
      <div className="h-[70vh]">
        <img
          src={LogoProsoft}
          className="rounded-md w-full h-full"
          alt="ProSoft"
        />
      </div>
    </>
  );
}

export default Home;
